import { useEffect, useMemo, useState } from "react";
import "@/App.css";
import "@/index.css";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import NumberSearch from "@/components/NumberSearch";
import Calculator from "@/components/Calculator";
import DateTools from "@/components/DateTools";
import Dictionary from "@/components/Dictionary";
import Journal from "@/components/Journal";
import Decodes from "@/components/Decodes";
import CiphersGuide from "@/components/CiphersGuide";
import PhraseAnalysis from "@/components/PhraseAnalysis";
import GetApp from "@/components/GetApp";
import Donate from "@/components/Donate";
import { fetchStats } from "@/lib/api";

const TABS = [
  { id: "search", label: "Number Search", testid: "tab-search" },
  { id: "decodes", label: "Decodes", testid: "tab-decodes" },
  { id: "calc", label: "Calculator", testid: "tab-calc" },
  { id: "date", label: "Date Tools", testid: "tab-date" },
  { id: "journal", label: "Journal", testid: "tab-journal" },
  { id: "dict", label: "Dictionary", testid: "tab-dict" },
  { id: "ciphers", label: "Ciphers", testid: "tab-ciphers" },
  { id: "app", label: "Get App", testid: "tab-app" },
  { id: "donate", label: "Donate", testid: "tab-donate" },
];

const TOASTER_OPTIONS = {
  style: {
    background: "#121216",
    border: "1px solid rgba(255,255,255,0.1)",
    color: "#E2E4E9",
  },
};

export default function App() {
  const params = useMemo(() => new URLSearchParams(window.location.search), []);
  const phraseId = params.get("phrase");
  const initialSearch = params.get("search");

  const [tab, setTab] = useState("search");
  const [stats, setStats] = useState({ total_phrases: 0, cipher_count: 0 });

  useEffect(() => {
    fetchStats().then(setStats).catch(() => {});
  }, [tab]);

  // Dedicated phrase-analysis route ( /?phrase=ID — opened in new browser tab )
  if (phraseId) {
    return (
      <div className="App bg-sacred">
        <PhraseAnalysis id={phraseId} />
        <Toaster theme="dark" position="bottom-right" toastOptions={TOASTER_OPTIONS} />
      </div>
    );
  }

  return (
    <div className="App bg-sacred">
      <Header tab={tab} setTab={setTab} tabs={TABS} stats={stats} />

      <main className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10 py-10 md:py-14">
        {tab === "search" && <NumberSearch initialValue={initialSearch} />}
        {tab === "decodes" && <Decodes />}
        {tab === "calc" && <Calculator />}
        {tab === "date" && <DateTools />}
        {tab === "journal" && <Journal onChange={() => fetchStats().then(setStats)} />}
        {tab === "dict" && <Dictionary onChange={() => fetchStats().then(setStats)} />}
        {tab === "ciphers" && <CiphersGuide />}
        {tab === "app" && <GetApp />}
        {tab === "donate" && <Donate />}
      </main>

      <footer className="relative z-10 mt-20 border-t border-white/10 px-6 md:px-10 py-8 text-xs muted font-mono">
        <div className="max-w-[1400px] mx-auto flex flex-wrap justify-between gap-4 items-center">
          <span className="flex items-center gap-2">
            <span aria-hidden="true">💎</span>
            <span><span className="gold">GEM</span> KEY</span>
            <span aria-hidden="true">🔑</span>
            <span className="mx-2 opacity-40">//</span>
            {stats.total_phrases} PHRASES
            <span className="mx-2 opacity-40">//</span>
            {stats.cipher_count} CIPHERS
          </span>
          <span>FOR RESEARCH &amp; DECODING ONLY</span>
        </div>
      </footer>

      <Toaster theme="dark" position="bottom-right" toastOptions={TOASTER_OPTIONS} />
    </div>
  );
}
